<script setup>
defineProps({
  width: {
    type: Number,
    default: 12,
  },
  height: {
    type: Number,
    default: 13,
  },
  hasOpacity: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <svg
    class="icon-ai"
    :class="{ 'has-opacity': hasOpacity }"
    :width="width"
    :height="height"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="IconAILinear" clip-path="url(#clip0_3358_18212)">
      <path
        id="Vector"
        d="M4.75013 12.5C4.6796 12.5 4.61037 12.481 4.5497 12.4451C4.48903 12.4091 4.43915 12.3575 4.4053 12.2956L2.92011 9.57976L0.20443 8.09448C0.14255 8.06063 0.0909173 8.01075 0.0549485 7.95008C0.0189797 7.8894 0 7.82017 0 7.74963C0 7.67909 0.0189797 7.60986 0.0549485 7.54918C0.0909173 7.4885 0.14255 7.43863 0.20443 7.40478L2.92011 5.9195L4.4053 3.20444C4.43915 3.14256 4.48902 3.09092 4.54969 3.05495C4.61037 3.01898 4.6796 3 4.75013 3C4.82066 3 4.8899 3.01898 4.95057 3.05495C5.01124 3.09092 5.06112 3.14256 5.09496 3.20444L6.58015 5.92002L9.29557 7.4053C9.35745 7.43915 9.40908 7.48903 9.44505 7.5497C9.48102 7.61038 9.5 7.67962 9.5 7.75015C9.5 7.82069 9.48102 7.88993 9.44505 7.9506C9.40908 8.01128 9.35745 8.06116 9.29557 8.09501L6.58015 9.57976L5.09496 12.2956C5.06111 12.3575 5.01123 12.4091 4.95056 12.4451C4.88989 12.481 4.82066 12.5 4.75013 12.5ZM1.21272 7.74963L3.39884 8.94534C3.46518 8.98167 3.51973 9.03623 3.55606 9.10257L4.7517 11.2888L5.94578 9.10048C5.98196 9.03403 6.03655 8.97943 6.10299 8.94325L8.28885 7.74753L6.10299 6.55208C6.03655 6.5159 5.98196 6.4613 5.94578 6.39485L4.75013 4.20886L3.55449 6.39485C3.51821 6.46123 3.46364 6.5158 3.39727 6.55208L1.21272 7.74963Z"
        fill="#434343"
      />
      <path
        id="Vector_2"
        d="M9.2501 6C9.19572 6 9.14234 5.98537 9.09556 5.95765C9.04879 5.92992 9.01033 5.89012 8.98423 5.84241L8.16155 4.33868L6.65762 3.516C6.60991 3.4899 6.5701 3.45144 6.54237 3.40466C6.51463 3.35788 6.5 3.3045 6.5 3.25012C6.5 3.19574 6.51463 3.14236 6.54237 3.09558C6.5701 3.0488 6.60991 3.01034 6.65762 2.98424L8.16155 2.16156L8.98423 0.657622C9.01032 0.60991 9.04878 0.5701 9.09556 0.542367C9.14234 0.514634 9.19572 0.5 9.2501 0.5C9.30448 0.5 9.35786 0.514634 9.40464 0.542367C9.45142 0.5701 9.48988 0.60991 9.51598 0.657622L10.3384 2.16156L11.8424 2.98505C11.8901 3.01115 11.9299 3.0496 11.9576 3.09638C11.9854 3.14316 12 3.19654 12 3.25093C12 3.30531 11.9854 3.35869 11.9576 3.40547C11.9299 3.45225 11.8901 3.49071 11.8424 3.5168L10.3384 4.33868L9.51598 5.84262C9.48985 5.89028 9.45138 5.93005 9.4046 5.95774C9.35782 5.98542 9.30446 6.00002 9.2501 6ZM7.43464 3.25012L8.53046 3.84935C8.58169 3.87725 8.62378 3.91934 8.65168 3.97057L9.2501 5.066L9.84933 3.97037C9.8771 3.91905 9.91923 3.87692 9.97055 3.84915L11.0662 3.24992L9.97055 2.65068C9.91932 2.62279 9.87723 2.5807 9.84933 2.52946L9.2501 1.43464L8.65168 2.53027C8.62378 2.5815 8.58169 2.6236 8.53046 2.65149L7.43464 3.25012Z"
        fill="#434343"
      />
      <path
        id="Vector_3"
        d="M10.2202 12.4999C10.1571 12.4999 10.0951 12.4829 10.0408 12.4507C9.98654 12.4185 9.9419 12.3723 9.9116 12.317L9.45621 11.484L8.6235 11.0289C8.56812 10.9986 8.52192 10.9539 8.48973 10.8997C8.45754 10.8454 8.44055 10.7834 8.44055 10.7203C8.44055 10.6572 8.45754 10.5952 8.48973 10.5409C8.52192 10.4866 8.56812 10.442 8.6235 10.4117L9.45644 9.95628L9.91184 9.12334C9.94213 9.06797 9.98677 9.02177 10.0411 8.98959C10.0954 8.9574 10.1573 8.94043 10.2204 8.94043C10.2836 8.94043 10.3455 8.9574 10.3998 8.98959C10.4541 9.02177 10.4987 9.06797 10.529 9.12334L10.9844 9.95604L11.8174 10.4114C11.8728 10.4417 11.919 10.4864 11.9511 10.5407C11.9833 10.595 12.0003 10.6569 12.0003 10.72C12.0003 10.7832 11.9833 10.8451 11.9511 10.8994C11.919 10.9537 11.8728 10.9983 11.8174 11.0286L10.9847 11.4843L10.529 12.317C10.4987 12.3724 10.454 12.4186 10.3997 12.4508C10.3454 12.483 10.2834 12.4999 10.2202 12.4999ZM9.52515 10.72L9.88417 10.9163C9.94363 10.9487 9.99249 10.9976 10.0249 11.057L10.2211 11.4158L10.4174 11.057C10.4498 10.9976 10.4987 10.9487 10.5581 10.9163L10.9169 10.72L10.5581 10.5238C10.4987 10.4914 10.4498 10.4425 10.4174 10.3831L10.2211 10.024L10.0249 10.3831C9.99249 10.4425 9.94363 10.4914 9.88417 10.5238L9.52515 10.72Z"
        fill="#434343"
      />
    </g>
    <defs>
      <clipPath id="clip0_3358_18212">
        <rect
          width="12"
          height="12"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<style lang="scss" scoped>
.has-opacity {
  opacity: 0.5;
}
</style>
